import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GoToCheckout } from '../../../actions/cart';
import { ConfirmHotel } from '../../../actions/hotels';
import {
    HotelListItem,
} from '../../../components/single-product/hotels/HotelListItem';

export function HotelList() {
    const dispatch = useDispatch();

    const confirmedPackage = useSelector((state) => state.cart.confirmed_package);
    const confirmedTickets = useSelector((state) => state.cart.confirmed_tickets);

    const includedHotel = useSelector((state) => state.hotels.included_hotel);
    const availableHotels = useSelector((state) => state.hotels.available_hotels);
    const unavailableHotels = useSelector((state) => state.hotels.unavailable_hotels);

    const selectedHotelNights = useSelector((state) => state.hotels.selected_hotel_nights);
    const selectedHotelRange = useSelector((state) => state.hotels.selected_hotel_range);
    const selectedHotelRoomType = useSelector((state) => state.hotels.selected_hotel_room_type);

    const hotels = useMemo(() => {
        let hotels = availableHotels.concat(unavailableHotels);

        if (includedHotel == null || selectedHotelNights !== 0) {
            return hotels;
        }

        const hotelsWithoutIncludedHotel = hotels
            .filter(h => h !== includedHotel);

        return [includedHotel].concat(hotelsWithoutIncludedHotel);
    }, [includedHotel, availableHotels, unavailableHotels]);

    function _onConfirm(hotel) {
        dispatch(ConfirmHotel(hotel));
        dispatch(GoToCheckout());
    }

    return (
        <>
            {hotels.map((hotel) => {
                const price = hotel.ranges[selectedHotelNights][selectedHotelRange].price;
                const priceSingle = hotel.ranges[selectedHotelNights][selectedHotelRange].price_single;
                const priceTriple = hotel.ranges[selectedHotelNights][selectedHotelRange].price_tripple;

                return (
                    <HotelListItem
                        key={hotel.id}
                        hotel={hotel}
                        price={price}
                        priceSingle={priceSingle}
                        priceTripple={priceTriple}
                        available={availableHotels.indexOf(hotel) > -1}
                        includedPrice={confirmedPackage.hotel.price}
                        selectedHotelRoomType={selectedHotelRoomType}
                        confirmedTickets={confirmedTickets}
                        onSelect={_onConfirm}
                    />
                );
            })}
        </>
    );
}
